import PropTypes from 'prop-types'
import { Modal, ModalBody } from 'components/modal'
import InaccuracyReportForm from 'components/offer/inaccuracy-report-form'
import { offerProps } from 'components/offer/offer'

const InaccuracyReportModal = ({ show, onHide, offer, regItemId }) => {
  return (
    <Modal show={show} title={`What's wrong with this link?`} onHide={onHide}>
      <ModalBody>
        <InaccuracyReportForm
          offer={offer}
          regItemId={regItemId}
          onSubmit={onHide}
        />
      </ModalBody>
    </Modal>
  )
}

InaccuracyReportModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  offer: PropTypes.shape(offerProps),
  regItemId: PropTypes.number,
  productId: PropTypes.number,
}

export default InaccuracyReportModal
